import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/stdreq/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/stdreq/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/stdreq/getIndex?numreql=' + searchParams.numreql)
  }
}



// WEBPACK FOOTER //
// ./src/api/stdreq/index.js